import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { getReportByKey } from "../components/outputs/reportsConfig";
var QUERY_PARAM = "report";
export var useSelectedReport = function () {
    var history = useHistory();
    var queryParams = new URLSearchParams(history.location.search);
    var reportKey = queryParams.get(QUERY_PARAM);
    var selectedReportKey = reportKey && getReportByKey(reportKey) ? reportKey : null;
    var setSelectedReport = useCallback(function (reportKey) {
        var queryParams = new URLSearchParams(history.location.search);
        if (reportKey && getReportByKey(reportKey)) {
            queryParams.set(QUERY_PARAM, reportKey);
        }
        else {
            queryParams.delete(QUERY_PARAM);
        }
        history.push({ search: queryParams.toString() });
    }, [history]);
    return {
        selectedReportKey: selectedReportKey,
        setSelectedReport: setSelectedReport,
    };
};
